import { render } from "./WikiRequests.vue?vue&type=template&id=63ffaf3c"
import script from "./WikiRequests.vue?vue&type=script&lang=js"
export * from "./WikiRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__